import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatToolbar} from "@angular/material/toolbar";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {Observable} from "rxjs";
import {map, shareReplay} from "rxjs/operators";
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    AsyncPipe,
    MatIcon,
    MatIconButton,
    MatToolbar,
    BreadcrumbComponent,
    ProfileMenuComponent
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css'
})
export class TopBarComponent {
  /** Hide the hamburger when a bottom tab bar provides navigation (mobile). */
  @Input() showMenuButton = true;
  @Output() toggleDrawer: EventEmitter<void> = new EventEmitter<void>();
  private breakpointObserver = inject(BreakpointObserver);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

}
